import styled from 'styled-components';

import { StyleColor, NewStyleColor } from '../../../../utils/styles-constants';
import { hexToRgba } from '../../../../utils/style';

interface ButtonProps {
	isActive: boolean;
	disabled: boolean;
}

const Label = styled('ul')`
	display: flex;
	margin: 0 0 15px 30px;
	padding: 0;
	list-style-type: none;
`;

const LabelItem = styled('li')`
	flex: 0 0 25%;
	background-color: ${hexToRgba(NewStyleColor.Black, 10)};

	&:first-child {
		border-radius: 11px 0 0 11px;
	}

	&:last-child {
		border-radius: 0 11px 11px 0;
	}

	&:only-child {
		border-radius: 11px;
	}
`;

const Button = styled('button')`
	width: 100%;
	height: 30px;
	padding: 0 5px;
	background-color: transparent;
	font-family: HelveticaNeue, sans-serif;
	font-size: 12px;
	line-height: 30px;
	letter-spacing: 0.17px;
	text-align: center;
	color: ${(props: ButtonProps) => props.isActive
		? `${NewStyleColor.White}`
		: `${StyleColor.Blue600}`
	};
	white-space: nowrap;
	border-radius: 11px;
	border: 0;
	outline: 0;
	cursor: ${(props: ButtonProps) => props.disabled ? 'default' : 'pointer'};

	${(props: ButtonProps) => props.isActive && `
		background-color: ${NewStyleColor.Blue200};
	`}
`;

export {
	Label,
	LabelItem,
	Button,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/Label/styles.ts